import { type ApplicableInsuranceCareProviderListIds } from "@/modules/care-provider/simple-search/services/useCareProviderQuickListQuery"

export const isInsuranceCareProviderListMember = (
  careProviderInsuranceCareProviderListIds: ReadonlyArray<string> | null | undefined,
  applicableInsuranceCareProviderListIds: ApplicableInsuranceCareProviderListIds | undefined,
): boolean =>
  (careProviderInsuranceCareProviderListIds ?? []).some(
    (listId) => applicableInsuranceCareProviderListIds?.includes(listId) ?? false,
  )
